import { css } from 'styled-components';

export default {
  container: css`
    background-color: transparent;
    padding: 1em;
    display: flex;
    flex-wrap:wrap;
    align-items: center;
    justify-content: space-around;
    border-radius: 0;
    outline: none;
    border: none;
    width: 100%;
    max-width: 900px;
  `,
};
